import React from 'react';
import { isEmpty } from 'lodash-es';
import { fetchTemplates } from 'constants/api';
import getTemplatesData from '../fn/getTemplatesData';

const WithTemplatesFetch = (Component) => {
  return class extends React.Component {
    state = {
      tabs: [],
      routes: [],
      categories: [],
      templates: {},
    };

    async componentDidMount() {
      const templates = await fetchTemplates();
      const data = getTemplatesData(templates);

      this.setState(data);
    }

    render() {
      const { templates } = this.state;

      return !isEmpty(templates) ? (
        <Component {...this.state} {...this.props} />
      ) : null;
    }
  };
};

export default WithTemplatesFetch;
